import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { createStaticTranslateKey } from '../lib/create-static-translate-key';
import { getFullPath } from '../lib/get-full-path';
import { PICFLOW_ANALYTICS } from '../picflow-analytics';
import { AuthRedirectService } from '../services/auth-redirect.service';
import { BrowserService } from '../services/browser.service';
import { RedirectService } from '../services/redirect.service';
import { ToastService } from '../services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInRedirectGuard {
  private redirectService = inject(RedirectService);
  private browserService = inject(BrowserService);
  private authRedirectService = inject(AuthRedirectService);
  private analytics = inject(PICFLOW_ANALYTICS);
  private toasts = inject(ToastService);

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    const loggedIn = this.browserService.getCookies()?.['picflow-loggedin'] === 'true';
    if (!loggedIn) return true;

    const path = getFullPath(next);

    if (path[0] === 'r') {
      if (!this.toasts.toasts$.value.length) {
        this.toasts.add(
          createStaticTranslateKey(
            'Invites are only valid for new accounts',
            'toasts.invites-only-valid-for-new-accounts'
          ),
          'error',
          { duration: 5000 }
        );
      }
    }

    if (path[0] === 'auth' && ['login', 'signup'].includes(path[1])) {
      if (next.queryParams.__clerk_ticket) return true;
      if (next.queryParams.redirect_url) return true;
      return this.authRedirectService.redirectAfterLogin(next);
    }

    if (!this.analytics.lastUrl && path.length === 0) {
      return this.authRedirectService.redirectAfterLogin(next);
    }

    if (['promo', 'pricing'].includes(path[0])) {
      return this.redirectService.redirectTo(['a', 'pricing']);
    }
    return true;
  }
}
